import Button from 'react-bootstrap/Button'

function SearchAgainButton() {
  const handleClick = () => { document.location = "/" }
  return <Button variant="primary" onClick={handleClick}>Search Again</Button>
}

export default SearchAgainButton
